



















































import { Component, Vue } from 'vue-property-decorator';
import { RootActionCreateTopic, RootMutationShowDialog, Dialog } from '@/store/interface';
import { Action, Mutation } from 'vuex-class';
import { rootActions, rootMutations } from '@/store/types';
import { PostNewTopicData } from '@/interface';
import { Log } from '@/utils';

const items = ['分享', '问答', '招聘', '客户端测试'];
const itemsValue = {
  [items[0]]: 'share',
  [items[1]]: 'ask',
  [items[2]]: 'job',
  [items[3]]: 'dev',
};
@Component
export default class Create extends Vue {
  private select = items[3];
  private items = [...items];
  private title = '';
  private content = '';
  private titleRules = [
    (v: string) => !!v || '标题 必填',
    (v: string) => v.length >= 10 || '标题字数10个以上',
  ];
  private contentRules = [
    (v: string) => !!v || '正文 必填',
    (v: string) => v.length >= 10 || '正文字数10个以上',
  ];
  private valid: boolean = false;
  @Action(rootActions.CREATE_TOPIC)
  private createTopic!: RootActionCreateTopic;
  @Mutation(rootMutations.SHOW_DIALOG)
  private showDialog!: RootMutationShowDialog;
  private async newTopic() {
    const topic: PostNewTopicData = Object.create(null);
    topic.title = this.title;
    topic.content = this.content;
    topic.tab = itemsValue[this.select];
    const isOk = await this.createTopic(topic);
    if (isOk) {
      const dialog: Dialog = {
        title: '发布成功!',
        content: '前去查看该主题？',
        successCb: () => {
          this.$router.replace(`/topic/${isOk.topic_id}`);
        },
        failCb: () => {
          this.$router.back();
        },
      };
      this.showDialog(dialog);
      this.select = items[3];
      this.title = '';
      this.content = '';
    }
  }
}
